import { useState } from 'react'
import { ToolInvocationUIPart } from 'ai'
import { SuggestTopic } from '@deepguide-ai/types'
import { ChevronUp } from 'lucide-react'
import { AnimatePresence, motion } from 'motion/react'
import { cn } from '@/lib/utils'
import { useTopicAtomsContext } from '@/hooks/useTopicAtomsContext'
import { Button } from '@deepguide-ai/ui/button'
// import { CopyButton } from '@/components/animate-ui/buttons/copy'
import CodeBlockLayout from '../CodeBlockLayout'
import NoResults from './NoResults'

const TopicSuggestionWithContentMessage = ({
  part,
  icon,
}: {
  part: ToolInvocationUIPart
  icon: React.ReactNode
}) => {
  const [showDetails, setShowDetails] = useState(true)
  const { editorRef } = useTopicAtomsContext()
  /* FIXME(@ai-sdk-upgrade-v5): The `part.toolInvocation.state` property has been removed. Please manually migrate following https://ai-sdk.dev/docs/migration-guides/migration-guide-5-0#tool-part-type-changes-uimessage */
  const topicSuggestion: SuggestTopic | null =
    part.toolInvocation.state === 'result'
      ? part.toolInvocation.result.arguments
      : null;

  const action: string | null = topicSuggestion?.action ?? null

  /* FIXME(@ai-sdk-upgrade-v5): The `part.toolInvocation.state` property has been removed. Please manually migrate following https://ai-sdk.dev/docs/migration-guides/migration-guide-5-0#tool-part-type-changes-uimessage */
  const error: Error | null =
    part.toolInvocation.state === 'result'
      ? part.toolInvocation.result.error
      : null;

  // console.log('>>> topicSuggestion', part, topicSuggestion)

  const handleApply = () => {
    // apply the topic suggestion
    console.log('>>> apply topic suggestion', topicSuggestion)
  }

  const actions = (
    <>
      {/* <CopyButton
        getContent={handleCopy}
        className='h-[22px] w-[22px] rounded-md !p-0.5 [&_svg]:size-[14px]'
        variant='ghost'
      /> */}
      <Button
        variant='ghost'
        className='hover:!bg-accent h-[22px] rounded-sm !px-1.5'
        onClick={handleApply}
      >
        Apply
      </Button>
    </>
  )

  /* FIXME(@ai-sdk-upgrade-v5): The `part.toolInvocation.state` property has been removed. Please manually migrate following https://ai-sdk.dev/docs/migration-guides/migration-guide-5-0#tool-part-type-changes-uimessage */
  return (
    <div className='flex w-full flex-col items-start gap-0'>
      <Button
        variant='ghost'
        className='group/icon inline-flex h-auto w-full min-w-16 items-center justify-start gap-2 bg-transparent px-3 py-2.5 hover:bg-transparent'
        onClick={() => setShowDetails(!showDetails)}
      >
        <div className='text-muted-foreground flex w-4 shrink-0 items-center justify-center'>
          <div>{icon}</div>
        </div>

        <span
          className={cn(
            'text-foreground flex-1 text-left text-[14px] leading-5 font-medium tracking-[0] break-words whitespace-normal'
          )}
        >
          {error ? (
            <span className='text-destructive'>
              Topic generation failed: {error.message}
            </span>
          ) : (
            <>
              {part.toolInvocation.state === 'result'
                ? action === 'assign_existing'
                  ? 'Suggest edit existing topic'
                  : action === 'create_new'
                    ? 'Suggested new topic'
                    : ''
                : 'Suggesting topic'}
            </>
          )}
        </span>
        <ChevronUp
          className={cn('size-4 transition-transform duration-300', {
            'rotate-180': !showDetails,
          })}
          strokeWidth={2}
        />
      </Button>
      <AnimatePresence>
        {/* {showDetails && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{
              height: { duration: 0.2, ease: [0.23, 1, 0.32, 1] },
              opacity: { duration: 0.15 },
            }}
            className='w-full overflow-hidden'
          >
            <CodeBlockLayout
              title={topicSuggestion?.newTopicTitle ?? 'New topic'}
              actions={actions}
            >
              {topicSuggestion?.content ? (
                
              ) : (
                <NoResults />
              )}
            </CodeBlockLayout>
          </motion.div>
        )} */}
      </AnimatePresence>
    </div>
  );
}

export default TopicSuggestionWithContentMessage
